import React from 'react';

/**
 * Component BoxContent
 * @param Object jsx props.children
 */
const BoxContent = (props) => {
  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <div>
      {props.children}
    </div>
  )
}

export default BoxContent;